export default __webpack_public_path__ + "static/media/geolocation.a15f75e2.svg";